import React, { useContext, useState } from 'react';
import { Button, Checkbox, Col, Row, message, Spin, Form, Collapse } from 'antd';
import { FileProtectOutlined, CaretRightOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import './styles.less';
import EnrollmentService from '../../../../../EnrollmentPage/EnrollmentService';
import { EnrollmentFormContext } from '../../../../../../providers/EnrollmentFormContextProvider';
import Paragraph from '../../../../../../components/common/Paragraph';
import ContractService from '../../../../../EnrollmentPage/ContractService';
import TermsAndConditions from '../../../../../EnrollmentPage/components/steps/ContractsStep/TermsAndConditions';
import { EnrollmentContext } from '../../../../../../providers/EnrollmentContextProvider';
import enrollmentAction from '../../../../../../providers/EnrollmentContextProvider/enrollmentAction';

const Contract = ({ onFinish }) => {
  const [isLoading, setLoading] = useState(false);
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const { dispatch, enrollment } = useContext(EnrollmentContext);
  const { Panel } = Collapse;

  const contracts = enrollment?.vehicles || [];
  // const annexed = enrollment.products;

  const declaringPersonEmail = enrollmentForm.getFieldValue(['declaringPerson', 'email']);
  // const declaringPersonName = enrollmentForm.getFieldValue(['declaringPerson', 'name']);
  const legalRepresentativeEmail = enrollmentForm.getFieldValue(['legalRepresentative', 'email']);
  // const legalRepresentativeName = enrollmentForm.getFieldValue(['legalRepresentative', 'name']);

  const handleSubmit = () => {
    setLoading(true);
    EnrollmentService.finishEnrollmentForm({ id: enrollment.id })
      .then((response) => {
        dispatch({
          type: enrollmentAction.SET_TRACKING_NUMBER,
          payload: response.data.trackingNumber,
        });
        onFinish();
      })
      .catch(() => {
        message.error('Error inesperado. Por favor, intente nuevamente.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const downloadContract = async (contractId) => {
    setLoading(true);
    ContractService.getContract(contractId)
      .then(({ data }) => {
        const file = new Blob([data], { type: 'application/pdf' });
        const fileUrl = URL.createObjectURL(file);
        window.open(fileUrl, '_blank', 'noopener');
      })
      .catch(() => {
        message.error('Error inesperado. Por favor, intente nuevamente.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const downloadConyugal = async () => {
    setLoading(true);
    ContractService.getArt150(enrollment.id)
      .then(({ data }) => {
        const file = new Blob([data], { type: 'application/pdf' });
        const fileUrl = URL.createObjectURL(file);
        window.open(fileUrl, '_blank', 'noopener');
      })
      .catch(() => {
        message.error('Error inesperado. Por favor, intente nuevamente.');
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const downloadUAF = async () => {
    setLoading(true);
    ContractService.getUAF(enrollment.id)
      .then(({ data }) => {
        const file = new Blob([data], { type: 'application/pdf' });
        const fileUrl = URL.createObjectURL(file);
        window.open(fileUrl, '_blank', 'noopener');
      })
      .catch(() => {
        message.error('Error inesperado. Por favor, intente nuevamente.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  function Conditions({ contractId }) {
    return (
      <Row>
        <Col span={20}>
          <Form.Item
            name={`contractTermsAndConditions${contractId}`}
            rules={[
              {
                validator: (_, value) => {
                  if (!value)
                    return Promise.reject(new Error('Debe aceptar los términos y condiciones'));
                  return Promise.resolve();
                },
              },
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              <span className="contract__checkbox--text">
                He leído y estoy de acuerdo con todos los términos y condiciones establecidas en el
                contrato
              </span>
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
    );
  }
  Conditions.propTypes = {
    contractId: PropTypes.string.isRequired,
  };

  return (
    <Spin spinning={isLoading}>
      <Form form={enrollmentForm} onFinish={handleSubmit}>
        <Row>
          <Col>
            <p className="contract__title--bold"> Firma de Contratos</p>
          </Col>
        </Row>
        <Collapse
          accordion
          className="contract__body__collapse"
          expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
        >
          {contracts.map((vehicle) => (
            <Panel header={vehicle.name} className="contract__title" key={vehicle.id}>
              {vehicle.contracts.map((contract) => (
                <contracts>
                  <Row gutter={[10]}>
                    <Col xs={3} lg={2}>
                      <div className="contract__icon">
                        <FileProtectOutlined />
                      </div>
                    </Col>

                    <Col span={22}>
                      <Paragraph strong noBottomMargin>
                        {contract.name}
                      </Paragraph>

                      <Button
                        type="link"
                        style={{ padding: 0 }}
                        onClick={() => downloadContract(contract.id)}
                      >
                        <Paragraph underline>Ver contrato</Paragraph>
                      </Button>
                    </Col>
                  </Row>
                  <terms>
                    <Conditions contractId={contract.id} />
                  </terms>
                </contracts>
              ))}

              {vehicle.products.map((product) =>
                product.contracts.map((contract) => (
                  <anexxed>
                    <Row gutter={[10]}>
                      <Col xs={3} lg={2}>
                        <div className="contract__icon__annexed">
                          <FileProtectOutlined />
                        </div>
                      </Col>

                      <Col span={22}>
                        <Paragraph strong noBottomMargin>
                          {contract.name}
                        </Paragraph>

                        <Button
                          type="link"
                          style={{ padding: 0 }}
                          onClick={() => downloadContract(contract.id)}
                        >
                          <Paragraph underline>Ver Anexo</Paragraph>
                        </Button>
                      </Col>
                    </Row>

                    <terms>
                      <Conditions contractId={contract.id} />
                    </terms>
                  </anexxed>
                ))
              )}

              <Row>
                <Col span={24}>
                  <Form.Item style={{ marginBottom: 0 }}>
                    <TermsAndConditions />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col lg={20} xs={24}>
                  <Form.Item
                    name="enrollmentPolicy"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (!value)
                            return Promise.reject(
                              new Error('Debe aceptar la política de enrolamiento')
                            );
                          return Promise.resolve();
                        },
                      },
                    ]}
                    valuePropName="checked"
                  >
                    <Checkbox>
                      <span className="contract__checkbox--text">
                        He leído y estoy de acuerdo con la Pólitica de enrolamiento, envío de
                        operaciones y comunicaciones mediante sistemas electrónicos o digitales.
                      </span>
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          ))}
        </Collapse>
        <br />
        {enrollment.figureType === 'NATURAL' && enrollment?.person?.inversionsFollowArticle150 && (
          <Row>
            <Col>
              <Paragraph strong noBottomMargin>
                Declaración Soc. Conyugal
              </Paragraph>

              <Button type="link" style={{ padding: 0 }} onClick={() => downloadConyugal()}>
                <Paragraph underline>Descargar declaración</Paragraph>
              </Button>
            </Col>
          </Row>
        )}
        {enrollment.figureType === 'LEGAL' &&
          enrollment.legalRepresentatives &&
          enrollment.legalRepresentatives.some((lr) => lr.societyType) && (
            <Row>
              <Col>
                <Paragraph strong noBottomMargin>
                  Formulario UAF
                </Paragraph>

                <Button type="link" style={{ padding: 0 }} onClick={() => downloadUAF()}>
                  <Paragraph underline>Descargar UAF</Paragraph>
                </Button>
              </Col>
            </Row>
          )}
        <Row>
          {/* <Col lg={20} xs={24}>
            <p className="contract__subtitle">
              Los contratos y borradores se enviarán al Representante Legal seleccionado como principal
              {declaringPersonEmail ? (
                <span>{declaringPersonEmail}</span>
              ) : (
                <span>{legalRepresentativeEmail}</span>
              )}
            </p>
          </Col> */}
        </Row>
        <Row>
          <Col lg={20} xs={24}>
            <p className="contract__subtitle">
              Uuna vez finalice el proceso de verificación de datos, los contratos finales serán
              enviados al correo electrónico indicado.{' '}
              <span className="contract__bold">
                {declaringPersonEmail || legalRepresentativeEmail}
              </span>{' '}
              En primer lugar, se enviará una copia borrador de los contratos y una vez finalice el
              proceso de verificación de datos se enviará el contrato final para su firma
              correspondiente.
            </p>
          </Col>
        </Row>
        <Row gutter={[40]}>
          <Col lg={12} xs={24}>
            <Button
              className="enrollmentLegalFormContainer__button"
              style={{ marginTop: '30%' }}
              type="primary"
              htmlType="submit"
            >
              Continuar
            </Button>
          </Col>
        </Row>{' '}
      </Form>
    </Spin>
  );
};

Contract.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default Contract;
